import React, { useContext, useEffect } from 'react'
import { StoresContext } from '@App/contexts'
import { useNavigate, useParams } from 'react-router'
import './index.scss'
import OverclaimViewHeader from '@Components/OverclaimView/Headers/OverclaimViewHeader'
import { observer } from 'mobx-react'
import OverclaimExtendedWorkItem from '@Components/WorkItemV2/OverclaimAndDisputes/OverclaimExtendedWorkItem'
import TabsWrapperComponent, { Tab } from '@Components/TabsWrapperComponent'
import OverclaimDetailTab from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDetailTab'
import clsx from 'clsx'
import OverclaimHistoryTab from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimHistoryTab'
import OverclaimDocumentTab from '@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView/OverclaimDocumentTab'
import { useFlag } from '@openfeature/react-sdk'
import { PARAM } from '@App/navigation/param'
import Navigation from '@App/navigation'

const OverclaimView = () => {
    const { overclaimViewStore, preloaderStore, rightsholderStore } = useContext(StoresContext)
    const params = useParams<typeof PARAM>()
    const navigate = useNavigate()
    const { value: showDocumentUpload } = useFlag('overclaim-document-upload', false)

    const overclaimHeaderId = params.overclaimHeaderId && +params.overclaimHeaderId

    const overclaimTabs: Tab[] = [
        {
            tabName: 'Detail',
            tabDisplayName: 'Detail',
            tabComponent: (
                <OverclaimDetailTab
                    onAmend={() => overclaimViewStore.amendOverclaim()}
                    onClickUploadDocumentsOption={() =>
                        navigate(
                            Navigation.rightholder.overclaim.uploadDocuments(
                                rightsholderStore.currentRightsholderId,
                                overclaimHeaderId!
                            )
                        )
                    }
                />
            ),
        },
        ...(showDocumentUpload
            ? [
                  {
                      tabName: 'Documents',
                      tabDisplayName: 'Documents',
                      tabComponent: (
                          <OverclaimDocumentTab
                              onClickUploadDocumentsOption={() =>
                                  navigate(
                                      Navigation.rightholder.overclaim.uploadDocuments(
                                          rightsholderStore.currentRightsholderId,
                                          overclaimHeaderId!
                                      )
                                  )
                              }
                          />
                      ),
                  },
              ]
            : []),
        {
            tabName: 'History',
            tabDisplayName: 'History',
            tabComponent: <OverclaimHistoryTab />,
        },
    ]
    useEffect(() => {
        if (
            !overclaimViewStore.overclaimViewItem ||
            (overclaimHeaderId && overclaimViewStore.overclaimViewItem?.overclaimHeaderId !== overclaimHeaderId)
        ) {
            if (overclaimHeaderId) {
                preloaderStore.openMainPreloader(true)
                overclaimViewStore
                    .getOverclaimViewItemByHeaderId(overclaimHeaderId, rightsholderStore.currentRightsholderId)
                    .finally(() => {
                        preloaderStore.openMainPreloader(false)
                    })
            } else {
                navigate(`/member/${rightsholderStore.currentRightsholderId}`)
            }
        }
    }, [])

    return (
        <>
            <title>Overclaim Detail</title>
            {overclaimViewStore.overclaimViewItem && (
                <div className={clsx('overclaim-view-container')}>
                    <OverclaimViewHeader songTitle={overclaimViewStore.overclaimViewItem.title} />
                    <div className="overclaim-view-item">
                        <div className="overclaim-view-item-body">
                            <div className="total-overclaim-container">
                                <OverclaimExtendedWorkItem work={overclaimViewStore.overclaimViewItem} toCatalog />
                            </div>
                            <TabsWrapperComponent
                                tabs={overclaimTabs}
                                defaultTab={overclaimTabs[0]}
                                preventScrollReset
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
export default observer(OverclaimView)
